import React, { useEffect, useState } from 'react';
import { TranslationService } from '../../../core/services';
import styles from './Help.module.scss';
import Mark from 'mark.js';
import { Form } from '../../../core/components';

const Help = () => {
  const [markInstance, setMarkInstance] = useState<any>();

  const handleKeypress = (e: any) => {
    markInstance.unmark({
      done: function () {
        markInstance.mark(e.target.value);
      },
    });
  };

  useEffect(() => {
    const helpPageContent = document.getElementById(
      'helpPageContent'
    ) as HTMLElement;

    setMarkInstance(new Mark(helpPageContent));
  }, []);

  return (
    <>
      <div className="container">
        <h1 className={styles.pageTitle}>
          {TranslationService.translate('Help')}
        </h1>
        <div className={styles.searchPanel}>
          <Form.Group variant={Form.Group.Variants.Inline}>
            <Form.Label for="searchWord">
              {TranslationService.translate('InputSearchPlaceholder')}
            </Form.Label>

            <input
              id="searchWord"
              className={styles.inputSearch}
              type="text"
              name="searchWord"
              onKeyUp={handleKeypress}
            />
          </Form.Group>
        </div>

        <div
          id="helpPageContent"
          className={styles.help}
          dangerouslySetInnerHTML={{
            __html: TranslationService.translate('HelpQuestions'),
          }}
        ></div>
      </div>
    </>
  );
};

export default Help;
